import { render, staticRenderFns } from "./testinCentre.vue?vue&type=template&id=45c56220&scoped=true&"
import script from "./testinCentre.vue?vue&type=script&lang=js&"
export * from "./testinCentre.vue?vue&type=script&lang=js&"
import style0 from "./testinCentre.vue?vue&type=style&index=0&id=45c56220&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45c56220",
  null
  
)

export default component.exports